module.exports = __webpack_public_path__ + "static/media/fire.86bec852.gif";